// TODO: Use react-router https://auctane.atlassian.net/browse/PS-1452
export const useIsInSupportCenter = (): boolean => {
    return window.location.pathname.includes('support-center');
};
